const cardPreviewMixin = {
    computed: {
        styleInfo() {
            const layout = this.store.formData.impl;
            if (layout) {
                return {
                    width: layout.width ? `${layout.width + 30}px` : '430px',
                    height: layout.height ? `${layout.height + 30}px` : '630px'
                };
            }
            return {
                width: '430px',
                height: '630px'
            };
        },
        isPC() {
            const layout = this.store.formData.impl;
            return layout ? layout.format === 'DEFAULT' : false;
        }
    }
};
export default cardPreviewMixin;